"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sourceFileHelper = require("../../utils/sourceFileHelper");
var _SourceItems = require("../../constants/SourceItems");
var _TemplateChooser = require("./TemplateChooser.styled");
var _hooks = require("../../hooks");
var _feature = require("@studio/feature.flags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function TemplateItem(_ref) {
  var item = _ref.item,
    handleChange = _ref.handleChange,
    index = _ref.index,
    title = _ref.title,
    containerElementSelector = _ref.containerElementSelector,
    isSelected = _ref.isSelected;
  var key = item.key,
    name = item.name,
    _id = item._id;
  var eventDocRef = key || _id || name;
  var fileType = (0, _sourceFileHelper.getFileSourceType)(name || key);
  var isValidTemplateSourceType = _SourceItems.templateSourceTypes.has(fileType);
  var elementRef = (0, _react.useRef)(null);
  var isInView = (0, _hooks.useElementInViewport)({
    elementRef: elementRef,
    containerElementSelector: containerElementSelector
  });
  var renderMediaItem = function renderMediaItem(_ref2, index, mediaTitle) {
    var url = _ref2.url,
      key = _ref2.key;
    var mediaTemplateId = "media-template-id-".concat(index);
    switch (fileType) {
      case _SourceItems.IMAGE_FILE:
        return _react["default"].createElement(_TemplateChooser.StyledTemplateMedia, null, _react["default"].createElement("img", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }));
      case _SourceItems.VIDEO_FILE:
        return _react["default"].createElement(_TemplateChooser.StyledTemplateMedia, null, (0, _feature.shouldHaveFeature)('studio.hls') && !key ? _react["default"].createElement("img", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }) : _react["default"].createElement("video", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }));
      case _SourceItems.AUDIO_FILE:
        return _react["default"].createElement(_TemplateChooser.StyledTemplateMedia, null, _react["default"].createElement("audio", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }));
      default:
        return null;
    }
  };
  return isValidTemplateSourceType && item.url && _react["default"].createElement(_TemplateChooser.StyledTemplateItem, {
    ref: elementRef,
    key: index,
    "data-testid": "template-".concat(eventDocRef, "-wrapper")
  }, _react["default"].createElement("label", {
    htmlFor: "template-".concat(eventDocRef, "-radio-button"),
    className: "image-checkbox",
    title: eventDocRef
  }, _react["default"].createElement(_TemplateChooser.StyledRadioInput, {
    "data-testid": "template-".concat(index, "-radio-button"),
    type: "radio",
    name: "templateChooser",
    value: eventDocRef,
    onChange: handleChange,
    id: "template-".concat(eventDocRef, "-radio-button"),
    checked: isSelected
  }), isInView ? renderMediaItem(item, index, title) : _react["default"].createElement(_TemplateChooser.StyledTemplateMedia, {
    "data-testid": "default-media"
  })), _react["default"].createElement(_TemplateChooser.StyledMediaTitle, null, title));
}
TemplateItem.propTypes = {
  item: _propTypes["default"].shape({
    key: _propTypes["default"].string,
    name: _propTypes["default"].string,
    url: _propTypes["default"].string,
    _id: _propTypes["default"].string
  }),
  handleChange: _propTypes["default"].func,
  index: _propTypes["default"].number,
  title: _propTypes["default"].string,
  containerElementSelector: _propTypes["default"].string,
  isSelected: _propTypes["default"].bool
};
var _default = exports["default"] = TemplateItem;